import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const defaultOptions = { format: null, defaultStr: "-" };
type Options = Partial<typeof defaultOptions>;
export const formatDate = (dateString: string | undefined | null | dayjs.Dayjs, full: boolean = false, options: Options = defaultOptions): string => {
    const mapOptions = { ...defaultOptions, ...options };
    if (!dateString) return mapOptions.defaultStr;
    if (!isValidDate(dateString)) return mapOptions.defaultStr;

    const date = dayjs(dateString);
    if (!date?.isValid()) return mapOptions.defaultStr;


    const format = mapOptions.format ? mapOptions.format : full ? "DD MMM YYYY | hh:mm A" : "DD MMM YYYY";
    return date.format(format);
};

export const isValidDate = (date: dayjs.Dayjs | string | null | undefined) => {
    if (!date)
        return false;

    if (typeof date === 'string') {
        const formattedDate = new Date(date);
        return !isNaN(formattedDate.getTime());
    } else {
        const validDate = dayjs(date);
        return validDate.isValid();
    }
}

export const getDateByDateAndTime = (_date: string | null | undefined, _time: string | null | undefined) => {
    if (!_date || !_time || !isValidDate(_date) || !isValidDate(_time))
        return;

    const date = dayjs(_date);  // Date object
    const time = dayjs(_time);  // Time object

    const year = date.year();
    const month = date.month();
    const day = date.date();

    const hour = time.hour();
    const minute = time.minute();
    const second = time.second();
    const millisecond = time.millisecond();

    return dayjs().year(year).month(month).date(day)
        .hour(hour).minute(minute).second(second).millisecond(millisecond);
}

export const isAfterToday = (_date: string | null | undefined) => {
    if (!_date || !isValidDate(_date))
        return false;

    const today = dayjs().startOf('day');
    const inputDate = dayjs(_date);
    return inputDate.isAfter(today, "day");
}

export const isAfterMonthBefore = (_date: string | null | undefined) => {
    if (!_date || !isValidDate(_date))
        return false;

    const today = dayjs().startOf('day');
    const MonthBeforeInput = dayjs(_date).subtract(1, 'month');
    return MonthBeforeInput.isAfter(today, "day");
}

export const isBeforeToday = (_date: string | null | undefined) => {
    if (!_date || !isValidDate(_date))
        return false;

    const today = dayjs();
    const inputDate = dayjs(_date);
    return inputDate.isBefore(today);
}

export const getUTCStartDayTime = (_date: any) => {
    if (!_date || !dayjs(_date).isValid())
        return dayjs().startOf("day");
    return dayjs(_date).startOf("day")
}

export const getRelativeTime = (dateString: string | null | undefined) => {
    if (!dateString || !isValidDate(dateString)) return '-';

    const date = dayjs(dateString);
    const now = dayjs();
    const diffTime = Math.abs(now.diff(date));
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Yesterday";
    return `${diffDays}d ago`;
};